import React from 'react';
import GTMDataLayer from '../../Utility/GTMDataLayer';

const RadioButtonV2 = ({
  id,
  value,
  name,
  className,
  labelName,
  labelClassName,
  onClick,
  register,
  checked,
  gtm_question,
  gtm_trigger,
  gtm_answer,
  clickevent,
  dataBsDismiss,
  divClass,
  spanclass,
  onChange,
  labelClass
}) => {
  const handleClick = (e) => {
    // if (e.target.dataset.gtm_trigger) {
    //   GTMDataLayer({
    //     clickEvent: e.target.dataset.clickevent,
    //     question: e.target.dataset.gtm_question,
    //     answer: e.target.dataset.gtm_answer,
    //   });
    // }
    // if (onClick) {
    //   onClick(e);
    // }
  };

  return (
    <>
      <input
        type="radio"
        className={className}
        name={name}
        id={id}
        value={value}
        onClick={onChange}
        onChange={onChange}
        {...register}
        checked={checked}
        data-gtm_question={gtm_question}
        data-gtm_trigger={gtm_trigger}
        data-gtm_answer={gtm_answer}
        data-clickevent={clickevent}
        data-bs-dismiss={dataBsDismiss}
      />
      <label
        htmlFor={id}
        className={labelClassName !== '' ? labelClassName : ''}
      >
        {divClass !== '' ? (
          <>
            <div className={divClass}>
              <span className={spanclass} />{' '}
            </div>
            <div className={labelClass}>{labelName}</div>
          </>
        ) : (
          labelName
        )}
      </label>
    </>
  );
};

export default RadioButtonV2;
